import {
  AddMedicalHistory,
  MedicalHistoryListType,
  MedicalHistoryType,
} from "@/common/types";
import { Input } from "@/components/ui/input";
import { addMedicalHistory } from "@/redux/actions/usersActions";
import { RootState } from "@/redux/reducers";
import { convertDateToString } from "@/utils/date.util";
import { SendHorizontal } from "lucide-react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

interface MedicalHistoryProps {
  patientId: number;
}

const MedicalHistory: React.FC<MedicalHistoryProps> = ({ patientId }) => {
  const { medicalHistory } = useSelector((state: RootState) => state.users);
  const medicalHistoryList: MedicalHistoryType[] = (
    medicalHistory as MedicalHistoryListType
  )?.results;

  const [formState, setFormState] = useState({
    note: "",
  });
  const [error, setError] = useState<string>("");

  const dispatch: any = useDispatch();

  const handleChange = (key: string, value: string) => {
    setFormState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const validateInput = () => {
    let errorMessage = "";
    if (!formState.note || formState.note === "") {
      errorMessage = "Enter a note";
    } else {
      errorMessage = "";
    }
    setError(errorMessage);
    return errorMessage;
  };

  const handleSendNotes = () => {
    const errorMessage = validateInput();
    if (!errorMessage) {
      const payload: AddMedicalHistory = {
        patient_id: patientId,
        note: formState.note,
      };

      dispatch(
        addMedicalHistory(payload, () => {
          setFormState({ note: "" });
        })
      );
    }
  };

  return (
    <div>
      <div className="flex flex-col gap-4 mb-4">
        {medicalHistoryList?.map(
          (medicalHistory: MedicalHistoryType, index: number) => (
            <div key={index}>
              <div>
                {medicalHistory.created_by.name} - (
                {convertDateToString(medicalHistory.created_at)})
              </div>
              <div>{medicalHistory.note}</div>
            </div>
          )
        )}
        {medicalHistoryList?.length === 0 && <p>No Medical History found</p>}
      </div>
      {error && <p className="text-red-500 text-sm py-1">{error}</p>}
      <div className="flex items-center gap-2">
        <Input
          id="notes"
          name="notes"
          value={formState.note}
          onChange={(e) => handleChange("note", e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSendNotes()}
        />
        <SendHorizontal
          className="w-6 h-6 cursor-pointer"
          onClick={() => handleSendNotes()}
        />
      </div>
    </div>
  );
};

export default MedicalHistory;
